export default __webpack_public_path__ + "static/media/disclaimer.06c13067.png";